/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TaskDataImageUrl } from '../../../../../../../models/task.model';
import { Logger, LogService } from '@epg/angular-base-lib';

@Component({
  selector: 'app-image-url-item',
  templateUrl: './image-url-item.component.html',
  styleUrls: ['./image-url-item.component.scss'],
  standalone: false
})
export class ImageUrlItemComponent implements OnInit {
  @Input() imageItem?: TaskDataImageUrl;

  private log: Logger;

  constructor(logService: LogService) {
    this.log = logService.getLogger(this);
  }

  get imageUrl(): string | undefined {
    return this.imageItem?.value;
  }

  ngOnInit(): void {
    this.log.debug('onInit', 'imageItem.value:', this.imageItem?.value);
  }
}
